module.exports = __webpack_public_path__ + "img/telegram.278f3bc4.png";